import React from 'react';

// Shared SVG wrapper props
const base = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  style: { flexShrink: 0, display: 'block' },
};

// ── Type Icons ─────────────────────────────────────────────────────────────
// Guiding principle: abstract forms only — no people, no chat bubbles.
// Proximity and softness carry the warmth.

// Open circle — universal, no context assumed
export const GeneralIcon = () => (
  <svg {...base}>
    <circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// Centre dot + 3 surrounding — collective, facing a shared centre
export const TeamIcon = () => (
  <svg {...base}>
    <circle cx="8" cy="8"    r="1.4" fill="currentColor" />
    <circle cx="8" cy="3.0"  r="0.9" fill="currentColor" opacity="0.7" />
    <circle cx="12.7" cy="10.7" r="0.9" fill="currentColor" opacity="0.7" />
    <circle cx="3.3"  cy="10.7" r="0.9" fill="currentColor" opacity="0.7" />
  </svg>
);

// Two dots — close, direct, no crowd
export const ColleagueIcon = () => (
  <svg {...base}>
    <circle cx="4.5" cy="8" r="1.5" fill="currentColor" />
    <circle cx="11.5" cy="8" r="1.5" fill="currentColor" />
  </svg>
);

// Warm cluster — informal, organic, slightly uneven spacing
export const FriendsIcon = () => (
  <svg {...base}>
    <circle cx="5.5" cy="5.5" r="1.5" fill="currentColor" opacity="0.85" />
    <circle cx="11"  cy="6.5" r="1.5" fill="currentColor" opacity="0.85" />
    <circle cx="7.5" cy="11"  r="1.5" fill="currentColor" opacity="0.85" />
  </svg>
);

// Two shapes — near each other, not identical (one slightly larger)
export const RelationshipIcon = () => (
  <svg {...base}>
    <circle cx="5.5" cy="8" r="2.2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <circle cx="11"  cy="8" r="1.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

// Single dot — contained, still, self-sufficient
export const SoloIcon = () => (
  <svg {...base}>
    <circle cx="8" cy="8" r="2.5" fill="currentColor" />
  </svg>
);

// ── Level Icons ────────────────────────────────────────────────────────────
// Visual logic: all share the same centre form.
// Same light — different states. Reach increases with depth.

// One point of light, tight and contained. One soft ring.
export const SparkIcon = () => (
  <svg {...base}>
    <circle cx="8" cy="8" r="1.5" fill="currentColor" />
    <circle cx="8" cy="8" r="4.2" stroke="currentColor" strokeWidth="1" opacity="0.35" />
  </svg>
);

// Centre point + two concentric rings — glow is spreading
export const DepthIcon = () => (
  <svg {...base}>
    <circle cx="8" cy="8" r="1.5"  fill="currentColor" />
    <circle cx="8" cy="8" r="3.6"  stroke="currentColor" strokeWidth="1"    opacity="0.52" />
    <circle cx="8" cy="8" r="5.6"  stroke="currentColor" strokeWidth="0.75" opacity="0.24" />
  </svg>
);

// Three rings — outermost nearly fading. The light fills the room.
export const BreakthroughIcon = () => (
  <svg {...base}>
    <circle cx="8" cy="8" r="1.5"  fill="currentColor" />
    <circle cx="8" cy="8" r="3.2"  stroke="currentColor" strokeWidth="1"    opacity="0.58" />
    <circle cx="8" cy="8" r="5.2"  stroke="currentColor" strokeWidth="0.75" opacity="0.30" />
    <circle cx="8" cy="8" r="6.9"  stroke="currentColor" strokeWidth="0.5"  opacity="0.13" />
  </svg>
);

// ── Icon map keyed by option value ─────────────────────────────────────────
export const TodayIcon = () => (
  <svg {...base}>
    {/* Centre dot with 4 short radiating marks — this moment, today */}
    <circle cx="8" cy="8" r="1.8" fill="currentColor" />
    <line x1="8" y1="2.2" x2="8" y2="4.2"   stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <line x1="8" y1="11.8" x2="8" y2="13.8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <line x1="2.2" y1="8"  x2="4.2" y2="8"  stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <line x1="11.8" y1="8" x2="13.8" y2="8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const ICON_MAP = {
  // special
  today:        TodayIcon,
  // types
  general:      GeneralIcon,
  team:         TeamIcon,
  colleague:    ColleagueIcon,
  friends:      FriendsIcon,
  relationship: RelationshipIcon,
  solo:         SoloIcon,
  // levels
  spark:        SparkIcon,
  depth:        DepthIcon,
  breakthrough: BreakthroughIcon,
};
